import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useEffect, useState } from 'react';
import Button from '../components/common/Button';

// Import official icons
import IconPower from '../assets/Hooray-Assets/Icons/icon-power.svg';
import IconConsumption from '../assets/Hooray-Assets/Icons/icon-consumption.svg';
import IconMoney from '../assets/Hooray-Assets/Icons/icon-money.svg';

function Home() {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [authMessage, setAuthMessage] = useState('');

  // Check for any messages passed through navigation state
  useEffect(() => {
    if (location.state?.message) {
      setAuthMessage(location.state.message);
      // Clear the message from location state to prevent showing on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  return (
    <div>
      {/* Auth Message Alert */}
      {authMessage && (
        <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-6" role="alert">
          <p>{authMessage}</p>
        </div>
      )}

      {/* Hero Section */}
      <section className="py-12 md:py-20">
        <div className="text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-hooray-red font-mont">
            Reliable Energy Solutions
          </h1>
          <p className="text-xl text-hooray-red mb-8 max-w-3xl mx-auto">
            Hooray Power provides reliable backup solar solutions for homes and businesses.
            Purchase electricity, monitor usage, and manage your account all in one place.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            {isAuthenticated() ? (
              <Button to="/dashboard" variant="cta" size="lg">
                Go to Dashboard
              </Button>
            ) : (
              <>
                <Button 
                  to="/login" 
                  variant="cta" 
                  size="lg" 
                  className="min-w-[150px] justify-center"
                >
                  Login
                </Button>
                <Button 
                  to="/register" 
                  variant="cta"
                  size="lg" 
                  className="min-w-[150px] justify-center"
                >
                  Register
                </Button>
              </>
            )}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-12 bg-hooray-beige">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-hooray-red font-mont">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Feature 1 */}
            <div className="card text-center items-center flex flex-col bg-hooray-beige-40 shadow-lg rounded-xl p-6">
              <img src={IconPower} alt="" className="h-16 w-16 mb-6 text-hooray-yellow" />
              <h3 className="text-xl font-bold mb-3 font-mont text-hooray-red">Prepaid Electricity</h3>
              <p className="text-hooray-red">
                Purchase electricity credits instantly and manage your consumption efficiently.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="card text-center items-center flex flex-col bg-hooray-beige-40 shadow-lg rounded-xl p-6">
              <img src={IconConsumption} alt="" className="h-16 w-16 mb-6 text-hooray-yellow" />
              <h3 className="text-xl font-bold mb-3 font-mont text-hooray-red">Usage Monitoring</h3>
              <p className="text-hooray-red">
                Track your electricity usage with detailed reports and visualizations.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="card text-center items-center flex flex-col bg-hooray-beige-40 shadow-lg rounded-xl p-6">
              <img src={IconMoney} alt="" className="h-16 w-16 mb-6 text-hooray-yellow" />
              <h3 className="text-xl font-bold mb-3 font-mont text-hooray-red">Secure Payments</h3>
              <p className="text-hooray-red">
                Make secure payments using multiple payment methods through our Yoco integration.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-hooray-red text-white relative overflow-hidden">
        <div 
          className="absolute top-0 left-0 w-[1900px] h-[800px] bg-hooray-beige opacity-20 rounded-full transform -translate-x-1/2 -translate-y-1/4 z-0"
          aria-hidden="true"
        ></div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h2 className="text-3xl font-bold mb-6 font-mont">Ready to Get Started?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Join thousands of satisfied customers who trust Hooray Power for their energy needs.
          </p>
          {!isAuthenticated() && (
            <Button
              to="/register"
              variant="ctaSecondary"
              size="lg"
            >
              Create an Account
            </Button>
          )}
        </div>
      </section>
    </div>
  );
}

export default Home; 